const createExploreLeaveGuardSlice = (set) => ({
  exploreLeaveGuard: null,
  setExploreLeaveGuard: (guard) => set({ exploreLeaveGuard: guard })
});

export default createExploreLeaveGuardSlice;
